export default function ButtonDialogPrimary({label,clickEvent}){
    return(
        <div className="dialog-action-1" onClick={clickEvent}>{label}</div>
    )
}